import {LlmRun} from "common/flowmaster/types/llm_run";

export default function getStatus(llmRun: LlmRun) {
  return llmRun.is_complete
    ? "Complete"
    : llmRun.has_failed
    ? "Failed"
    : "In progress";
}
